<template>
  <condoleances />
</template>

<script>
import Condoleances from '../components/Raadplegen/Condoleances.vue'

export default {
  name: 'CondoleancesView',
  components: {
    Condoleances
  }
}
</script>
